import Icon from '@/components/ui/AppIcon';

interface TrainingModuleCardProps {
  title: string;
  category: string;
  duration: string;
  completionRate: number;
  enrolled: number;
  certified: number;
  lastUpdated: string;
}

export default function TrainingModuleCard({
  title,
  category,
  duration,
  completionRate,
  enrolled,
  certified,
  lastUpdated
}: TrainingModuleCardProps) {
  return (
    <div className="bg-card rounded-lg border border-border p-6 hover:shadow-lg transition-all duration-base">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <h3 className="text-lg font-headline font-bold text-foreground mb-1">{title}</h3>
          <p className="text-sm font-body text-muted-foreground">{category}</p>
        </div>
        <div className="flex-shrink-0 w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="AcademicCapIcon" size={24} variant="outline" className="text-primary" />
        </div>
      </div>
      
      <div className="space-y-3 mb-4">
        <div className="flex items-center justify-between">
          <span className="text-sm font-body text-muted-foreground">Completion Rate</span>
          <span className="text-sm font-body font-semibold text-foreground">{completionRate}%</span>
        </div>
        <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
          <div 
            className="bg-success h-full rounded-full transition-all duration-base"
            style={{ width: `${completionRate}%` }}
          ></div>
        </div>
      </div>
      
      <div className="grid grid-cols-2 gap-4 mb-4">
        <div className="flex items-center space-x-2">
          <Icon name="ClockIcon" size={16} variant="outline" className="text-primary" />
          <div>
            <p className="text-xs font-body text-muted-foreground">Duration</p>
            <p className="text-sm font-body font-semibold text-foreground">{duration}</p>
          </div>
        </div>
        
        <div className="flex items-center space-x-2">
          <Icon name="UserGroupIcon" size={16} variant="outline" className="text-primary" />
          <div>
            <p className="text-xs font-body text-muted-foreground">Enrolled</p>
            <p className="text-sm font-body font-semibold text-foreground">{enrolled}</p>
          </div>
        </div>
        
        <div className="flex items-center space-x-2">
          <Icon name="ShieldCheckIcon" size={16} variant="outline" className="text-primary" />
          <div>
            <p className="text-xs font-body text-muted-foreground">Certified</p>
            <p className="text-sm font-body font-semibold text-foreground">{certified}</p>
          </div>
        </div>
        
        <div className="flex items-center space-x-2">
          <Icon name="CalendarIcon" size={16} variant="outline" className="text-primary" />
          <div>
            <p className="text-xs font-body text-muted-foreground">Updated</p>
            <p className="text-sm font-body font-semibold text-foreground">{lastUpdated}</p>
          </div>
        </div>
      </div>
      
      <button className="w-full px-4 py-2.5 bg-primary text-primary-foreground rounded-md text-sm font-cta font-bold hover:opacity-90 transition-all duration-base flex items-center justify-center space-x-2">
        <Icon name="PlayIcon" size={16} variant="solid" />
        <span>Start Training</span>
      </button>
    </div>
  );
}